import {
  evaluateChallengeMapAccess,
  evaluateMapAccess,
} from "@dailywars/core/entitlements/mapAccess";

import { MapPreviewImage } from "#/components/MapPreviewImage";
import { PlayMapCta } from "#/components/PlayMapCta";
import { CardContent } from "#/components/ui/card";
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from "#/components/ui/empty";
import { useRequestGameContext } from "#/lib/useRequestGameContext";

import { HERO_PREVIEW_BOX_PX } from "./-play.previewSizing";

export function LeaderboardMapHero({ mapId }: { mapId: string }) {
  const { entitlements } = useRequestGameContext();
  const access = evaluateMapAccess({ mapId, entitlements });

  return (
    <>
      <MapPreviewImage mapId={mapId} maxSize={HERO_PREVIEW_BOX_PX} />
      <PlayMapCta mapId={mapId} access={access} style={{ maxWidth: HERO_PREVIEW_BOX_PX }} />
    </>
  );
}

export function ChallengeLeaderboardMapHero({
  mapId,
  isLive,
  hidePlayCta = false,
}: {
  mapId: string;
  isLive: boolean;
  hidePlayCta?: boolean;
}) {
  const { entitlements } = useRequestGameContext();
  const access = evaluateChallengeMapAccess({ mapId, entitlements, forPlay: true });

  return (
    <>
      <MapPreviewImage mapId={mapId} maxSize={HERO_PREVIEW_BOX_PX} />
      {isLive && !hidePlayCta ? (
        <PlayMapCta
          mapId={mapId}
          access={access}
          playLink={{ to: "/challenge" }}
          style={{ maxWidth: HERO_PREVIEW_BOX_PX }}
        />
      ) : null}
    </>
  );
}

export function LeaderboardEmptyBody() {
  return (
    <CardContent className="py-12">
      <Empty className="border-0 p-0">
        <EmptyHeader>
          <EmptyTitle>No scores yet</EmptyTitle>
          <EmptyDescription>Be the first on the board.</EmptyDescription>
        </EmptyHeader>
      </Empty>
    </CardContent>
  );
}
